import _ from "lodash";

import { Cohort } from "../personas/types";

export const SET_COHORTS = "SET_COHORTS";
export const REFRESH_COHORT_METADATA = "REFRESH_COHORT_METADATA";
export const DELETE_COHORT = "DELETE_COHORT";
export const UPSERT_COHORT = "UPSERT_COHORT";

export interface CohortsState {
  cohorts: Cohort[];
}

const defaultState: CohortsState = {
  cohorts: [],
};

function cohortsReducer(
  state = defaultState,
  action: { type: string; payload: any },
): CohortsState {
  switch (action.type) {
    case SET_COHORTS:
      return { ...state, cohorts: action.payload };
    case UPSERT_COHORT: {
      const index = state.cohorts.findIndex(
        (cohort) => cohort.id === action.payload.id,
      );
      const updatedCohorts = [...state.cohorts];
      if (index === -1) {
        updatedCohorts.push(action.payload);
      } else {
        updatedCohorts[index] = action.payload;
      }
      return { ...state, cohorts: updatedCohorts };
    }
    case DELETE_COHORT: {
      const newCohorts = state.cohorts.filter(
        (cohort) => cohort.id !== action.payload,
      );
      return { ...state, cohorts: newCohorts };
    }
    case REFRESH_COHORT_METADATA: {
      const cohortCopy = [...state.cohorts];
      const payload = action.payload as Cohort[];
      for (let cohort of payload) {
        const id = cohort.id;
        const index = _.findIndex(cohortCopy, (c) => c.id === id);

        if (cohortCopy[index]) {
          cohortCopy[index].synced_to = cohort.synced_to;
          cohortCopy[index].member_count = cohort.member_count;
          cohortCopy[index].is_pending = cohort.is_pending;
        }

        for (let destId in cohort.enabled_dests) {
          const dest = cohort.enabled_dests[destId];
          cohortCopy[index].enabled_dests[destId].synced_to = dest.synced_to;
          cohortCopy[index].enabled_dests[destId].is_syncing = dest.is_syncing;
        }
      }

      return { ...state, cohorts: cohortCopy };
    }
    default:
      return state;
  }
}
export default cohortsReducer;
